"use client";
import { jsx as h } from "react/jsx-runtime";
import { memo as r } from "react";
import t from "../components/Icon/SvgIcon.js";
const e = (o) => /* @__PURE__ */ h(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ h(
      "path",
      {
        fill: "currentColor",
        d: "M21.416 6.706h-.998l-1.102-2.533a1.54 1.54 0 0 0-1.403-.923H6.096c-.612 0-1.158.358-1.403.923L3.591 6.706H2.584A.587.587 0 0 0 2 7.29v3.766c0 .32.264.584.584.584h.414v8.446c0 .32.264.584.584.584h16.836c.32 0 .584-.264.584-.584V11.64h.414c.32 0 .584-.264.584-.584V7.29a.587.587 0 0 0-.584-.584M5.766 4.644a.35.35 0 0 1 .32-.217h11.827c.142 0 .264.085.32.217l.904 2.062H4.872l.904-2.062zM3.177 7.883h17.655v2.59H3.177zm5.301 11.629v-5.415h7.044v5.415zm11.347 0h-3.126v-6.008a.587.587 0 0 0-.584-.584h-8.22a.587.587 0 0 0-.584.584v6.008H4.185v-7.863h15.64z"
      }
    )
  }
), l = r(e);
export {
  l as Warehouse,
  l as default
};
